module.exports = __webpack_public_path__ + "static/media/brown.85a247b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/belts/brown.svg
// module id = 79
// module chunks = 0